import React, { useState, useEffect } from 'react';
import {
  Paper, Snackbar,
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Rating,
  Tooltip,
  IconButton,
  Button,
  Grid,
  Chip,
  LinearProgress,
  Modal, Card, CardContent, Alert, TablePagination
} from '@mui/material';
import axios from 'axios';
import { localAxiosGet } from '../../../Axios/axios';
import {
  AccessTime,
  CheckCircle,
  ThumbUp,
  Search,
  Info,
  Edit,
  MoreVert,
  Refresh,
  CompareArrows,
  History,
  TrendingUp,
  SupervisorAccount, PendingActions,
  Timeline,
  Group
} from "@mui/icons-material";


import GoalDetails from '../../../components/GoalDetails'


const EmployeeGoalsReview = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('All Statuses');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isGoalDetailsOpen, setIsGoalDetailsOpen] = useState(false)
  const [selectedCardFilter, setSelectedCardFilter] = useState('all');
  const [allEmployeesGoals, setAllEmployeesGoals] = useState([])
  const [dashboardCardDetails, setDashboardCardDetails] = useState({});
  const [selectedGoal, setSelectedGoal] = useState('');
  const userType = localStorage.getItem('userType')
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const userId = localStorage.getItem('userId');
  const [tablePage, setTablePage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const today = new Date();
  today.setHours(0, 0, 0, 0);


  const safeToFixed = (value, digits = 1) => {
    if (value === undefined || value === null) return '0.0';
    return Number(value).toFixed(digits);
  };

  const handleFilterChange = (event) => {
    setFilterStatus(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);

  };

  const handleOpenFeedbackDialog = () => {

  };


  const handleSelectedEmployeeGoal = (goalId) => {
    setIsGoalDetailsOpen(true);
    setSelectedGoal(goalId)
  }

  useEffect(() => {
    fetchDashboardCardStats();
  }, [])

  useEffect(() => {
    fetchAllEmployeeGoals();
  }, [filterStatus, selectedCardFilter]);


  const fetchDashboardCardStats = async () => {
    try {
      const response = await axios(localAxiosGet(`/performancemanagement/getEmployeeDashboardStats?reporting_manager_id=${userId}`));
      if (response.data.status === 'SUCCESS') {
        setDashboardCardDetails(response.data.result);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Error in fetching Dashboard Stats', error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || 'An error occurred',
        severity: 'error'
      });
    }
  };

  const fetchAllEmployeeGoals = async () => {
    try {
      const response = await axios(
        localAxiosGet(`/performancemanagement/getEmployeesByStatus?status=${filterStatus}&reporting_manager_id=${userId}`)
      );
      if (response.data.status === 'SUCCESS') {
        const rawData = response.data.result.data || [];

        // 🔑 Normalize into consistent shape
        const mappedData = rawData.map((emp) => {
          const firstName = emp.user?.first_name || emp.employee_data?.first_name || '';
          const lastName = emp.user?.last_name || emp.employee_data?.last_name || '';

          return {
            id: emp.id || emp.emp_id,
            name: `${firstName} ${lastName}`.trim() || 'Unknown Employee',
            position: emp.user?.designation?.designation || 'Unknown Position',
            department: emp.user?.department?.department || 'Unknown Department',
            status: emp.status || 'N/A',
            lastReviewDate: emp.updatedAt ? new Date(emp.updatedAt).toLocaleDateString() : 'N/A',
            overallRating: emp.overall_rating || 0,
            avatar: '', // API didn’t provide one, so fallback
          };
        });

        setAllEmployeesGoals(mappedData);
      }
    } catch (error) {
      console.log('Error in fetching employee goals', error);
    }
  };


  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const cardCategories = [
    {
      key: 'all',
      title: 'All Goals',
      icon: Group,
      colors: {
        background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
        icon: '#2196F3',
        text: '#2196F3',
        border: '#2196F3'
      },
      getCount: dashboardCardDetails.all_employees || 0,
      filterLogic: (employee) => true
    },
    {
      key: 'Pending', // Changed from 'pending'
      title: 'Pending',
      icon: AccessTime,
      colors: {
        background: 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)',
        icon: '#FF9800',
        text: '#FF9800',
        border: '#FF9800'
      },
      getCount: dashboardCardDetails.pending_review || 0,
      filterLogic: (employee) => employee.status === 'Pending'
    },
    {
      key: 'In Progress', // Changed from 'in_progress'
      title: 'In Progress',
      icon: Timeline,
      colors: {
        background: 'linear-gradient(135deg, #E0F7FA 0%, #B2EBF2 100%)',
        icon: '#00BCD4',
        text: '#00BCD4',
        border: '#00BCD4'
      },
      getCount: dashboardCardDetails.in_progress || 0,
      filterLogic: (employee) => employee.status === 'In Progress'
    },
    {
      key: 'Submitted For Review', // Changed from 'submitted_for_review'
      title: 'Submitted For Review',
      icon: CheckCircle,
      colors: {
        background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
        icon: '#4CAF50',
        text: '#4CAF50',
        border: '#4CAF50'
      },
      getCount: dashboardCardDetails.submitted_for_review || 0,
      filterLogic: (employee) => employee.status === 'Submitted For Review'
    },
  ];
  // --- Updated filteredEmployees Logic ---  
  const filteredEmployees = allEmployeesGoals.filter(employee => {
    const matchesDropdownStatus = filterStatus === 'All Statuses' || employee.status === filterStatus;
    const matchesSearch = employee.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.position.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.department.toLowerCase().includes(searchQuery.toLowerCase());

    // Find the current card filter logic based on selectedCardFilter
    const currentCardFilter = cardCategories.find(card => card.key === selectedCardFilter);
    const matchesCardFilter = currentCardFilter ? currentCardFilter.filterLogic(employee) : true; // Default to true if not found

    return matchesDropdownStatus && matchesSearch && matchesCardFilter;
  });


  const handleGoalDetailsModalClose = () =>{
    setIsGoalDetailsOpen(false);
    fetchAllEmployeeGoals();
  }
  const getStatusChip = (status) => {
    switch (status) {
      case 'Submitted For Review':
        return <Chip label="Submitted For Review" color="warning" size="small" icon={<AccessTime fontSize="small" />} />;
      case 'Pending':
        return <Chip label="Pending" color="error" size="small" icon={<PendingActions fontSize="small" />} />;
      case 'In Progress':
        return <Chip label="In Progress" color="info" size="small" icon={<Timeline fontSize="small" />} />;
      case 'Completed':
        return <Chip label="Completed" color="success" size="small" icon={<CheckCircle fontSize="small" />} />;
      default:
        return <Chip label={status} color="default" size="small" />;
    }
  };


  return (
    <div> <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Goals Overview
        </Typography>
        <Box sx={{ my: 2 }}>
          <Grid container spacing={3} mb={2}>
            {cardCategories.map((card) => {
              const IconComponent = card.icon;
              return (
                <Grid item xs={12} sm={6} md={3} key={card.key}>
                  <Card
                    sx={{
                      boxShadow: 3,
                      borderRadius: 2,
                      background: card.colors.background,
                      height: '100%',
                      cursor: 'pointer',
                      border: selectedCardFilter === card.key ? `2px solid ${card.colors.border}` : 'none'
                    }}
                    onClick={() => setSelectedCardFilter(card.key)}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 3 }}>
                      <IconComponent sx={{ fontSize: 50, color: card.colors.icon }} />
                      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                        {card.title}
                      </Typography>
                      <Typography variant="h3" sx={{ mt: 1, fontWeight: 'bold', color: card.colors.text }}>
                        {card.getCount}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            placeholder="Search employees..."
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <Search sx={{ color: 'action.active', mr: 1 }} />
              ),
            }}
            sx={{ width: 250 }}
          />

          <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
            <InputLabel id="status-filter-label">Status</InputLabel>
            <Select
              labelId="status-filter-label"
              id="status-filter"
              value={filterStatus}
              onChange={handleFilterChange}
              label="Status"
            >
              <MenuItem value="All Statuses">All Statuses</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Submitted For Review">Submitted For Review</MenuItem>
              <MenuItem value="In Progress">In Progress</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
              <MenuItem value="Accepted">Accepted</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>


      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Employee</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Position</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Department</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Last Review</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Rating</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredEmployees
              .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
              .map((employee) => (
                <TableRow
                  key={employee.id}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                    backgroundColor: selectedEmployee?.id === employee.id ? 'rgba(33, 150, 243, 0.08)' : 'inherit'
                  }}
                  onClick={() => handleSelectedEmployeeGoal(employee.id)}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        alt={employee.name}
                        src={employee.avatar}
                        sx={{ mr: 2 }}
                      >
                        {employee.name.charAt(0)}
                      </Avatar>
                      <Typography variant="body1" fontWeight="medium">
                        {employee.name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{employee.position}</TableCell>
                  <TableCell>{employee.department}</TableCell>
                  <TableCell>{employee.lastReviewDate}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Rating
                        value={employee.overallRating}
                        precision={0.1}
                        readOnly
                        size="small"
                      />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {employee.overallRating.toFixed(1)}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{getStatusChip(employee.status)}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex' }}>
                      <Tooltip title="View Details">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectEmployee(employee);
                            handleSelectedEmployeeGoal(employee.id)
                          }}
                        >
                          <Info />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Start Review">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectEmployee(employee);
                            handleOpenFeedbackDialog();
                          }}
                          disabled={employee.status !== 'pending_review' && employee.status !== 'in_progress'}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      {/* 
                  <Tooltip title="More Actions">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMenuOpen(e);
                        handleSelectEmployee(employee);
                      }}
                    >
                      <MoreVert />
                    </IconButton>
                  </Tooltip> */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredEmployees.length} // total employees after filtering
        page={tablePage}
        onPageChange={(e, newPage) => setTablePage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setTablePage(0); // reset to first page when rowsPerPage changes
        }}
        rowsPerPageOptions={[5, 10, 25]}
      />


      {filteredEmployees.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <Typography variant="body1" color="text.secondary">
            No employees match your filters
          </Typography>
          <Button
            variant="text"
            startIcon={<Refresh />}
            onClick={() => {
              setFilterStatus('All Statuses');
              setSearchQuery('');
              setSelectedCardFilter('all');
            }}
            sx={{ mt: 1 }}

          >
            Reset Filters
          </Button>
        </Box>
      )}
    </Paper>



      {/* goal details modal */}
      <GoalDetails
        isOpen={isGoalDetailsOpen}
        onClose={handleGoalDetailsModalClose}
        selectedGoal={selectedGoal}
        isManager={userType === 'Manager'}

      />
      {/* <Modal
        open={isGoalDetailsOpen}
        onClose={() => setIsGoalDetailsOpen(false)}
      >
        <Box sx={{
          maxWidth: '80vw',
          maxHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          margin: 'auto',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          zIndex: "100"
        }}>
          {/* Scrollable Content */}
      {/* <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
            <GoalDetails />
          </Box> */}

      {/* Fixed Footer */}
      {/* <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
            <Button variant="outlined" color="primary" onClick={() => setIsGoalDetailsOpen(false)}>
              CLOSE
            </Button>
          </Box>
        </Box>
      </Modal> */}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </div>
  )
}

export default EmployeeGoalsReview;
